import cnpjValidator from './cnpjValidator';
import cpfValidator from './cpfValidator';
import removeAllNonNumberCharacters from '../removeAllNonNumberCharacters';

export const validateCPForCNPJ = (cpfOrCnpj: string | undefined): boolean => {
  if (!cpfOrCnpj) {
    return false;
  }

  if (removeAllNonNumberCharacters(cpfOrCnpj).length === 14) {
    const cnpjIsValid = cnpjValidator(cpfOrCnpj);

    if (cnpjIsValid) {
      return true;
    }

    return false;
  } else if (removeAllNonNumberCharacters(cpfOrCnpj).length === 11) {
    const cpfIsValid = cpfValidator(cpfOrCnpj);

    if (cpfIsValid) {
      return true;
    }

    return false;
  } else {
    return false;
  }
};
